<template>
    <div class="default-layout">
        <div class="mobHeader">
            <router-link to="/" class="logo">
                <img v-if="comp_id == 2" src="@/assets/img/ringobell_logo_white.png" alt="로고" height="21" class="logo" />
                <img v-else src="@/assets/img/syscall_logo_white.png" alt="로고" height="17" class="logo" />
            </router-link>
            <h1>{{ display_name }}</h1>
            <!-- <button type="button" class="ham" @click="toggleMenu">
          <i :class="menuOpen ? 'pi pi-times' : 'pi pi-align-justify'"></i>
        </button> -->

            <div class="profile" ref="profile">
                <!-- 프로필 아이콘 -->
                <div class="user-info">
                    <button type="button" class="profile-button" @click="toggleLogoutMenu">
                        <img :src="thumbnailUrl" alt="프로필" class="profile-icon" />
                        <i class="pi pi-angle-down"></i>
                    </button>
                    <!-- 로그아웃 버튼 -->
                    <div v-if="showLogoutMenu" class="logout-menu">
                        <button type="button" @click="logout" class="logout-button">로그아웃</button>
                    </div>
                </div>
            </div>
        </div>

        <div :class="{ mob_menuBox: true, visible: menuVisible }">
            <ul>
                <li>
                    <router-link :to="selectedUserId ? `/home?user_id=${selectedUserId}` : '/home'" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3540" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3540)">
                                <path
                                    d="M6 18.9997H9.34625V13.0575H14.6538V18.9997H18V9.99972L12 5.48047L6 9.99972V18.9997ZM4.5 20.4997V9.24972L12 3.60547L19.5 9.24972V20.4997H13.1538V14.5575H10.8463V20.4997H4.5Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>HOME</span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="selectedUserId ? `/alarm?user_id=${selectedUserId}` : '/alarm'" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3545" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3545)">
                                <path
                                    d="M9.30775 18.7494V17.2494H20.5V18.7494H9.30775ZM9.30775 12.7494V11.2494H20.5V12.7494H9.30775ZM9.30775 6.74944V5.24944H20.5V6.74944H9.30775ZM5.1635 19.6629C4.706 19.6629 4.31442 19.5 3.98875 19.1742C3.66292 18.8485 3.5 18.4569 3.5 17.9994C3.5 17.5419 3.66292 17.1504 3.98875 16.8247C4.31442 16.4989 4.706 16.3359 5.1635 16.3359C5.621 16.3359 6.01258 16.4989 6.33825 16.8247C6.66408 17.1504 6.827 17.5419 6.827 17.9994C6.827 18.4569 6.66408 18.8485 6.33825 19.1742C6.01258 19.5 5.621 19.6629 5.1635 19.6629ZM5.1635 13.6629C4.706 13.6629 4.31442 13.5 3.98875 13.1742C3.66292 12.8485 3.5 12.4569 3.5 11.9994C3.5 11.5419 3.66292 11.1504 3.98875 10.8247C4.31442 10.4989 4.706 10.3359 5.1635 10.3359C5.621 10.3359 6.01258 10.4989 6.33825 10.8247C6.66408 11.1504 6.827 11.5419 6.827 11.9994C6.827 12.4569 6.66408 12.8485 6.33825 13.1742C6.01258 13.5 5.621 13.6629 5.1635 13.6629ZM5.1635 7.66294C4.706 7.66294 4.31442 7.50002 3.98875 7.17419C3.66292 6.84852 3.5 6.45694 3.5 5.99944C3.5 5.54194 3.66292 5.15035 3.98875 4.82469C4.31442 4.49885 4.706 4.33594 5.1635 4.33594C5.621 4.33594 6.01258 4.49885 6.33825 4.82469C6.66408 5.15035 6.827 5.54194 6.827 5.99944C6.827 6.45694 6.66408 6.84852 6.33825 7.17419C6.01258 7.50002 5.621 7.66294 5.1635 7.66294Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>{{ alarmMenuName }}</span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="selectedUserId ? `/device?user_id=${selectedUserId}` : '/device'" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3550" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3550)">
                                <path
                                    d="M17.5577 20.9417H18.4423V18.4417H20.9423V17.5572H18.4423V15.0572H17.5577V17.5572H15.0577V18.4417H17.5577V20.9417ZM18 22.4994C16.7513 22.4994 15.6892 22.0616 14.8135 21.1859C13.9378 20.3103 13.5 19.2481 13.5 17.9994C13.5 16.7508 13.9378 15.6886 14.8135 14.8129C15.6892 13.9373 16.7513 13.4994 18 13.4994C19.2487 13.4994 20.3108 13.9373 21.1865 14.8129C22.0622 15.6886 22.5 16.7508 22.5 17.9994C22.5 19.2481 22.0622 20.3103 21.1865 21.1859C20.3108 22.0616 19.2487 22.4994 18 22.4994ZM9.30775 6.74944V5.24944H20.5V6.74944H9.30775ZM5.1635 19.6629C4.706 19.6629 4.31442 19.5 3.98875 19.1742C3.66292 18.8485 3.5 18.4569 3.5 17.9994C3.5 17.5419 3.66292 17.1504 3.98875 16.8247C4.31442 16.4989 4.706 16.3359 5.1635 16.3359C5.621 16.3359 6.01258 16.4989 6.33825 16.8247C6.66408 17.1504 6.827 17.5419 6.827 17.9994C6.827 18.4569 6.66408 18.8485 6.33825 19.1742C6.01258 19.5 5.621 19.6629 5.1635 19.6629ZM5.1635 13.6629C4.706 13.6629 4.31442 13.5 3.98875 13.1742C3.66292 12.8485 3.5 12.4569 3.5 11.9994C3.5 11.5419 3.66292 11.1504 3.98875 10.8247C4.31442 10.4989 4.706 10.3359 5.1635 10.3359C5.621 10.3359 6.01258 10.4989 6.33825 10.8247C6.66408 11.1504 6.827 11.5419 6.827 11.9994C6.827 12.4569 6.66408 12.8485 6.33825 13.1742C6.01258 13.5 5.621 13.6629 5.1635 13.6629ZM5.1635 7.66294C4.706 7.66294 4.31442 7.50002 3.98875 7.17419C3.66292 6.84852 3.5 6.45694 3.5 5.99944C3.5 5.54194 3.66292 5.15035 3.98875 4.82469C4.31442 4.49885 4.706 4.33594 5.1635 4.33594C5.621 4.33594 6.01258 4.49885 6.33825 4.82469C6.66408 5.15035 6.827 5.54194 6.827 5.99944C6.827 6.45694 6.66408 6.84852 6.33825 7.17419C6.01258 7.50002 5.621 7.66294 5.1635 7.66294Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>장치관리</span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="selectedUserId ? `/statistics?user_id=${selectedUserId}` : '/statistics'" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3555" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3555)">
                                <path
                                    d="M7.4 21.6538L6.34625 20.6L12.9 14.0308L16.4 17.5307L21.575 12.3558L22.6443 13.425L16.4 19.6538L12.9 16.1538L7.4 21.6538ZM4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V5.30775C2.5 4.80258 2.675 4.375 3.025 4.025C3.375 3.675 3.80258 3.5 4.30775 3.5H17.6923C18.1974 3.5 18.625 3.675 18.975 4.025C19.325 4.375 19.5 4.80258 19.5 5.30775V9.50775H4V18.6923C4 18.7692 4.03208 18.8398 4.09625 18.9038C4.16025 18.9679 4.23075 19 4.30775 19V20.5ZM4 8.00775H18V5.30775C18 5.23075 17.9679 5.16025 17.9038 5.09625C17.8398 5.03208 17.7692 5 17.6923 5H4.30775C4.23075 5 4.16025 5.03208 4.09625 5.09625C4.03208 5.16025 4 5.23075 4 5.30775V8.00775Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>통계데이터</span>
                    </router-link>
                </li>
                <li>
                    <router-link :to="selectedUserId ? `/setting?user_id=${selectedUserId}` : '/setting'" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3560" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3560)">
                                <path
                                    d="M9.69177 21.5L9.31102 18.4538C9.04318 18.3641 8.76852 18.2385 8.48702 18.077C8.20568 17.9153 7.9541 17.7422 7.73227 17.5577L4.91102 18.75L2.60352 14.75L5.04377 12.9058C5.02077 12.7571 5.00443 12.6077 4.99477 12.4578C4.9851 12.3078 4.98027 12.1583 4.98027 12.0095C4.98027 11.8673 4.9851 11.7228 4.99477 11.576C5.00443 11.4292 5.02077 11.2686 5.04377 11.0943L2.60352 9.25L4.91102 5.26925L7.72252 6.452C7.96368 6.261 8.2211 6.08633 8.49477 5.928C8.76843 5.76967 9.03735 5.64242 9.30152 5.54625L9.69177 2.5H14.3073L14.688 5.55575C14.988 5.66475 15.2594 5.792 15.5023 5.9375C15.7453 6.083 15.9905 6.2545 16.238 6.452L19.088 5.26925L21.3955 9.25L18.9168 11.123C18.9526 11.2845 18.9722 11.4355 18.9755 11.576C18.9787 11.7163 18.9803 11.8577 18.9803 12C18.9803 12.1358 18.977 12.274 18.9705 12.4145C18.9642 12.5548 18.9412 12.7154 18.9015 12.8963L21.361 14.75L19.0533 18.75L16.238 17.548C15.9905 17.7455 15.7379 17.9202 15.4803 18.072C15.2226 18.224 14.9585 18.3481 14.688 18.4443L14.3073 21.5H9.69177ZM10.9995 20H12.965L13.3245 17.3212C13.8348 17.1879 14.3012 16.9985 14.7235 16.753C15.146 16.5073 15.5534 16.1916 15.9458 15.8057L18.4303 16.85L19.415 15.15L17.2458 13.5155C17.3291 13.2565 17.3858 13.0026 17.4158 12.7537C17.4459 12.5051 17.461 12.2538 17.461 12C17.461 11.7397 17.4459 11.4884 17.4158 11.2463C17.3858 11.0039 17.3291 10.7564 17.2458 10.5038L19.434 8.85L18.4495 7.15L15.936 8.2095C15.6014 7.85183 15.2004 7.53583 14.7333 7.2615C14.2659 6.98717 13.7932 6.79292 13.315 6.67875L12.9995 4H11.015L10.684 6.66925C10.1738 6.78975 9.70277 6.97433 9.27077 7.223C8.8386 7.47183 8.42635 7.79233 8.03402 8.1845L5.54952 7.15L4.56502 8.85L6.72452 10.4595C6.64118 10.6968 6.58285 10.9437 6.54952 11.2C6.51618 11.4563 6.49952 11.7262 6.49952 12.0095C6.49952 12.2698 6.51618 12.525 6.54952 12.775C6.58285 13.025 6.63802 13.2718 6.71502 13.5155L4.56502 15.15L5.54952 16.85L8.02452 15.8C8.40402 16.1897 8.80977 16.5089 9.24177 16.7578C9.67393 17.0064 10.1515 17.1974 10.6745 17.3307L10.9995 20ZM12.011 15C12.843 15 13.551 14.708 14.135 14.124C14.719 13.54 15.011 12.832 15.011 12C15.011 11.168 14.719 10.46 14.135 9.876C13.551 9.292 12.843 9 12.011 9C11.1687 9 10.4581 9.292 9.87927 9.876C9.30043 10.46 9.01102 11.168 9.01102 12C9.01102 12.832 9.30043 13.54 9.87927 14.124C10.4581 14.708 11.1687 15 12.011 15Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>환경설정</span>
                    </router-link>
                </li>
                <li v-if="auth != '2'">
                    <router-link to="/admin" @click="closeMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_533_3560" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_533_3560)">
                                <path
                                    d="M9.69177 21.5L9.31102 18.4538C9.04318 18.3641 8.76852 18.2385 8.48702 18.077C8.20568 17.9153 7.9541 17.7422 7.73227 17.5577L4.91102 18.75L2.60352 14.75L5.04377 12.9058C5.02077 12.7571 5.00443 12.6077 4.99477 12.4578C4.9851 12.3078 4.98027 12.1583 4.98027 12.0095C4.98027 11.8673 4.9851 11.7228 4.99477 11.576C5.00443 11.4292 5.02077 11.2686 5.04377 11.0943L2.60352 9.25L4.91102 5.26925L7.72252 6.452C7.96368 6.261 8.2211 6.08633 8.49477 5.928C8.76843 5.76967 9.03735 5.64242 9.30152 5.54625L9.69177 2.5H14.3073L14.688 5.55575C14.988 5.66475 15.2594 5.792 15.5023 5.9375C15.7453 6.083 15.9905 6.2545 16.238 6.452L19.088 5.26925L21.3955 9.25L18.9168 11.123C18.9526 11.2845 18.9722 11.4355 18.9755 11.576C18.9787 11.7163 18.9803 11.8577 18.9803 12C18.9803 12.1358 18.977 12.274 18.9705 12.4145C18.9642 12.5548 18.9412 12.7154 18.9015 12.8963L21.361 14.75L19.0533 18.75L16.238 17.548C15.9905 17.7455 15.7379 17.9202 15.4803 18.072C15.2226 18.224 14.9585 18.3481 14.688 18.4443L14.3073 21.5H9.69177ZM10.9995 20H12.965L13.3245 17.3212C13.8348 17.1879 14.3012 16.9985 14.7235 16.753C15.146 16.5073 15.5534 16.1916 15.9458 15.8057L18.4303 16.85L19.415 15.15L17.2458 13.5155C17.3291 13.2565 17.3858 13.0026 17.4158 12.7537C17.4459 12.5051 17.461 12.2538 17.461 12C17.461 11.7397 17.4459 11.4884 17.4158 11.2463C17.3858 11.0039 17.3291 10.7564 17.2458 10.5038L19.434 8.85L18.4495 7.15L15.936 8.2095C15.6014 7.85183 15.2004 7.53583 14.7333 7.2615C14.2659 6.98717 13.7932 6.79292 13.315 6.67875L12.9995 4H11.015L10.684 6.66925C10.1738 6.78975 9.70277 6.97433 9.27077 7.223C8.8386 7.47183 8.42635 7.79233 8.03402 8.1845L5.54952 7.15L4.56502 8.85L6.72452 10.4595C6.64118 10.6968 6.58285 10.9437 6.54952 11.2C6.51618 11.4563 6.49952 11.7262 6.49952 12.0095C6.49952 12.2698 6.51618 12.525 6.54952 12.775C6.58285 13.025 6.63802 13.2718 6.71502 13.5155L4.56502 15.15L5.54952 16.85L8.02452 15.8C8.40402 16.1897 8.80977 16.5089 9.24177 16.7578C9.67393 17.0064 10.1515 17.1974 10.6745 17.3307L10.9995 20ZM12.011 15C12.843 15 13.551 14.708 14.135 14.124C14.719 13.54 15.011 12.832 15.011 12C15.011 11.168 14.719 10.46 14.135 9.876C13.551 9.292 12.843 9 12.011 9C11.1687 9 10.4581 9.292 9.87927 9.876C9.30043 10.46 9.01102 11.168 9.01102 12C9.01102 12.832 9.30043 13.54 9.87927 14.124C10.4581 14.708 11.1687 15 12.011 15Z"
                                    fill="#B3B3B3"
                                />
                            </g>
                        </svg>
                        <span>관리처 관리</span>
                    </router-link>
                </li>
            </ul>
            <a href="javascript:;" class="logout" @click="logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_533_3565" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_533_3565)">
                        <path
                            d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H12.0095V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H12.0095V20.5H5.30775ZM16.2308 16.2692L15.1923 15.1845L17.627 12.75H9.09625V11.25H17.627L15.1923 8.8155L16.2308 7.73075L20.5 12L16.2308 16.2692Z"
                            fill="white"
                        />
                    </g>
                </svg>
                <span>로그아웃</span>
            </a>
        </div>

        <div :class="['sidebar', { 'mini-sidebar': isMiniSidebar }]">
            <div class="head">
                <h1>
                    <router-link to="/">
                        <img v-if="comp_id == 2" src="@/assets/img/ringobell_logo_white.png" alt="로고" height="21" class="logo" />
                        <img v-else src="@/assets/img/syscall_logo_white.png" alt="로고" height="21" class="logo" />
                    </router-link>
                    <button type="button" @click="toggleSidebar" class="ham">
                        <i :class="iconClass"></i>
                    </button>
                </h1>
                <div class="profileBox">
                    <div class="profile">
                        <div class="imgBox">
                            <img :src="thumbnailUrl" alt="사용자썸네일" />
                        </div>
                        <div class="info">
                            <strong class="user">{{ userRole }}</strong>
                            <b class="loca">{{ display_name }}</b>
                        </div>
                    </div>
                </div>
            </div>
            <nav>
                <ul>
                    <li>
                        <router-link :to="selectedUserId ? `/home?user_id=${selectedUserId}` : '/home'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3540" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3540)">
                                    <path
                                        d="M6 18.9997H9.34625V13.0575H14.6538V18.9997H18V9.99972L12 5.48047L6 9.99972V18.9997ZM4.5 20.4997V9.24972L12 3.60547L19.5 9.24972V20.4997H13.1538V14.5575H10.8463V20.4997H4.5Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>HOME</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="selectedUserId ? `/alarm?user_id=${selectedUserId}` : '/alarm'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3545" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3545)">
                                    <path
                                        d="M9.30775 18.7494V17.2494H20.5V18.7494H9.30775ZM9.30775 12.7494V11.2494H20.5V12.7494H9.30775ZM9.30775 6.74944V5.24944H20.5V6.74944H9.30775ZM5.1635 19.6629C4.706 19.6629 4.31442 19.5 3.98875 19.1742C3.66292 18.8485 3.5 18.4569 3.5 17.9994C3.5 17.5419 3.66292 17.1504 3.98875 16.8247C4.31442 16.4989 4.706 16.3359 5.1635 16.3359C5.621 16.3359 6.01258 16.4989 6.33825 16.8247C6.66408 17.1504 6.827 17.5419 6.827 17.9994C6.827 18.4569 6.66408 18.8485 6.33825 19.1742C6.01258 19.5 5.621 19.6629 5.1635 19.6629ZM5.1635 13.6629C4.706 13.6629 4.31442 13.5 3.98875 13.1742C3.66292 12.8485 3.5 12.4569 3.5 11.9994C3.5 11.5419 3.66292 11.1504 3.98875 10.8247C4.31442 10.4989 4.706 10.3359 5.1635 10.3359C5.621 10.3359 6.01258 10.4989 6.33825 10.8247C6.66408 11.1504 6.827 11.5419 6.827 11.9994C6.827 12.4569 6.66408 12.8485 6.33825 13.1742C6.01258 13.5 5.621 13.6629 5.1635 13.6629ZM5.1635 7.66294C4.706 7.66294 4.31442 7.50002 3.98875 7.17419C3.66292 6.84852 3.5 6.45694 3.5 5.99944C3.5 5.54194 3.66292 5.15035 3.98875 4.82469C4.31442 4.49885 4.706 4.33594 5.1635 4.33594C5.621 4.33594 6.01258 4.49885 6.33825 4.82469C6.66408 5.15035 6.827 5.54194 6.827 5.99944C6.827 6.45694 6.66408 6.84852 6.33825 7.17419C6.01258 7.50002 5.621 7.66294 5.1635 7.66294Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>{{ alarmMenuName }}</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="selectedUserId ? `/device?user_id=${selectedUserId}` : '/device'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3550" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3550)">
                                    <path
                                        d="M17.5577 20.9417H18.4423V18.4417H20.9423V17.5572H18.4423V15.0572H17.5577V17.5572H15.0577V18.4417H17.5577V20.9417ZM18 22.4994C16.7513 22.4994 15.6892 22.0616 14.8135 21.1859C13.9378 20.3103 13.5 19.2481 13.5 17.9994C13.5 16.7508 13.9378 15.6886 14.8135 14.8129C15.6892 13.9373 16.7513 13.4994 18 13.4994C19.2487 13.4994 20.3108 13.9373 21.1865 14.8129C22.0622 15.6886 22.5 16.7508 22.5 17.9994C22.5 19.2481 22.0622 20.3103 21.1865 21.1859C20.3108 22.0616 19.2487 22.4994 18 22.4994ZM9.30775 6.74944V5.24944H20.5V6.74944H9.30775ZM5.1635 19.6629C4.706 19.6629 4.31442 19.5 3.98875 19.1742C3.66292 18.8485 3.5 18.4569 3.5 17.9994C3.5 17.5419 3.66292 17.1504 3.98875 16.8247C4.31442 16.4989 4.706 16.3359 5.1635 16.3359C5.621 16.3359 6.01258 16.4989 6.33825 16.8247C6.66408 17.1504 6.827 17.5419 6.827 17.9994C6.827 18.4569 6.66408 18.8485 6.33825 19.1742C6.01258 19.5 5.621 19.6629 5.1635 19.6629ZM5.1635 13.6629C4.706 13.6629 4.31442 13.5 3.98875 13.1742C3.66292 12.8485 3.5 12.4569 3.5 11.9994C3.5 11.5419 3.66292 11.1504 3.98875 10.8247C4.31442 10.4989 4.706 10.3359 5.1635 10.3359C5.621 10.3359 6.01258 10.4989 6.33825 10.8247C6.66408 11.1504 6.827 11.5419 6.827 11.9994C6.827 12.4569 6.66408 12.8485 6.33825 13.1742C6.01258 13.5 5.621 13.6629 5.1635 13.6629ZM5.1635 7.66294C4.706 7.66294 4.31442 7.50002 3.98875 7.17419C3.66292 6.84852 3.5 6.45694 3.5 5.99944C3.5 5.54194 3.66292 5.15035 3.98875 4.82469C4.31442 4.49885 4.706 4.33594 5.1635 4.33594C5.621 4.33594 6.01258 4.49885 6.33825 4.82469C6.66408 5.15035 6.827 5.54194 6.827 5.99944C6.827 6.45694 6.66408 6.84852 6.33825 7.17419C6.01258 7.50002 5.621 7.66294 5.1635 7.66294ZM9.30775 18.7494V17.2494H11.2963C11.2591 17.4994 11.2405 17.7494 11.2405 17.9994C11.2405 18.2494 11.2591 18.4994 11.2963 18.7494H9.30775ZM9.30775 12.7494V11.2494H18C17.2103 11.2494 16.4661 11.3821 15.7673 11.6474C15.0686 11.9129 14.4411 12.2803 13.8848 12.7494H9.30775Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>장치관리</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="selectedUserId ? `/statistics?user_id=${selectedUserId}` : '/statistics'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3555" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3555)">
                                    <path
                                        d="M7.4 21.6538L6.34625 20.6L12.9 14.0308L16.4 17.5307L21.575 12.3558L22.6443 13.425L16.4 19.6538L12.9 16.1538L7.4 21.6538ZM4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V5.30775C2.5 4.80258 2.675 4.375 3.025 4.025C3.375 3.675 3.80258 3.5 4.30775 3.5H17.6923C18.1974 3.5 18.625 3.675 18.975 4.025C19.325 4.375 19.5 4.80258 19.5 5.30775V9.50775H4V18.6923C4 18.7692 4.03208 18.8398 4.09625 18.9038C4.16025 18.9679 4.23075 19 4.30775 19V20.5ZM4 8.00775H18V5.30775C18 5.23075 17.9679 5.16025 17.9038 5.09625C17.8398 5.03208 17.7692 5 17.6923 5H4.30775C4.23075 5 4.16025 5.03208 4.09625 5.09625C4.03208 5.16025 4 5.23075 4 5.30775V8.00775Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>통계데이터</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="selectedUserId ? `/setting?user_id=${selectedUserId}` : '/setting'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3560" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3560)">
                                    <path
                                        d="M9.69177 21.5L9.31102 18.4538C9.04318 18.3641 8.76852 18.2385 8.48702 18.077C8.20568 17.9153 7.9541 17.7422 7.73227 17.5577L4.91102 18.75L2.60352 14.75L5.04377 12.9058C5.02077 12.7571 5.00443 12.6077 4.99477 12.4578C4.9851 12.3078 4.98027 12.1583 4.98027 12.0095C4.98027 11.8673 4.9851 11.7228 4.99477 11.576C5.00443 11.4292 5.02077 11.2686 5.04377 11.0943L2.60352 9.25L4.91102 5.26925L7.72252 6.452C7.96368 6.261 8.2211 6.08633 8.49477 5.928C8.76843 5.76967 9.03735 5.64242 9.30152 5.54625L9.69177 2.5H14.3073L14.688 5.55575C14.988 5.66475 15.2594 5.792 15.5023 5.9375C15.7453 6.083 15.9905 6.2545 16.238 6.452L19.088 5.26925L21.3955 9.25L18.9168 11.123C18.9526 11.2845 18.9722 11.4355 18.9755 11.576C18.9787 11.7163 18.9803 11.8577 18.9803 12C18.9803 12.1358 18.977 12.274 18.9705 12.4145C18.9642 12.5548 18.9412 12.7154 18.9015 12.8963L21.361 14.75L19.0533 18.75L16.238 17.548C15.9905 17.7455 15.7379 17.9202 15.4803 18.072C15.2226 18.224 14.9585 18.3481 14.688 18.4443L14.3073 21.5H9.69177ZM10.9995 20H12.965L13.3245 17.3212C13.8348 17.1879 14.3012 16.9985 14.7235 16.753C15.146 16.5073 15.5534 16.1916 15.9458 15.8057L18.4303 16.85L19.415 15.15L17.2458 13.5155C17.3291 13.2565 17.3858 13.0026 17.4158 12.7537C17.4459 12.5051 17.461 12.2538 17.461 12C17.461 11.7397 17.4459 11.4884 17.4158 11.2463C17.3858 11.0039 17.3291 10.7564 17.2458 10.5038L19.434 8.85L18.4495 7.15L15.936 8.2095C15.6014 7.85183 15.2004 7.53583 14.7333 7.2615C14.2659 6.98717 13.7932 6.79292 13.315 6.67875L12.9995 4H11.015L10.684 6.66925C10.1738 6.78975 9.70277 6.97433 9.27077 7.223C8.8386 7.47183 8.42635 7.79233 8.03402 8.1845L5.54952 7.15L4.56502 8.85L6.72452 10.4595C6.64118 10.6968 6.58285 10.9437 6.54952 11.2C6.51618 11.4563 6.49952 11.7262 6.49952 12.0095C6.49952 12.2698 6.51618 12.525 6.54952 12.775C6.58285 13.025 6.63802 13.2718 6.71502 13.5155L4.56502 15.15L5.54952 16.85L8.02452 15.8C8.40402 16.1897 8.80977 16.5089 9.24177 16.7578C9.67393 17.0064 10.1515 17.1974 10.6745 17.3307L10.9995 20ZM12.011 15C12.843 15 13.551 14.708 14.135 14.124C14.719 13.54 15.011 12.832 15.011 12C15.011 11.168 14.719 10.46 14.135 9.876C13.551 9.292 12.843 9 12.011 9C11.1687 9 10.4581 9.292 9.87927 9.876C9.30043 10.46 9.01102 11.168 9.01102 12C9.01102 12.832 9.30043 13.54 9.87927 14.124C10.4581 14.708 11.1687 15 12.011 15Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>환경설정</span>
                        </router-link>
                    </li>
                    <li v-if="auth != '2'">
                        <router-link to="/admin">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_533_3560" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_533_3560)">
                                    <path
                                        d="M9.69177 21.5L9.31102 18.4538C9.04318 18.3641 8.76852 18.2385 8.48702 18.077C8.20568 17.9153 7.9541 17.7422 7.73227 17.5577L4.91102 18.75L2.60352 14.75L5.04377 12.9058C5.02077 12.7571 5.00443 12.6077 4.99477 12.4578C4.9851 12.3078 4.98027 12.1583 4.98027 12.0095C4.98027 11.8673 4.9851 11.7228 4.99477 11.576C5.00443 11.4292 5.02077 11.2686 5.04377 11.0943L2.60352 9.25L4.91102 5.26925L7.72252 6.452C7.96368 6.261 8.2211 6.08633 8.49477 5.928C8.76843 5.76967 9.03735 5.64242 9.30152 5.54625L9.69177 2.5H14.3073L14.688 5.55575C14.988 5.66475 15.2594 5.792 15.5023 5.9375C15.7453 6.083 15.9905 6.2545 16.238 6.452L19.088 5.26925L21.3955 9.25L18.9168 11.123C18.9526 11.2845 18.9722 11.4355 18.9755 11.576C18.9787 11.7163 18.9803 11.8577 18.9803 12C18.9803 12.1358 18.977 12.274 18.9705 12.4145C18.9642 12.5548 18.9412 12.7154 18.9015 12.8963L21.361 14.75L19.0533 18.75L16.238 17.548C15.9905 17.7455 15.7379 17.9202 15.4803 18.072C15.2226 18.224 14.9585 18.3481 14.688 18.4443L14.3073 21.5H9.69177ZM10.9995 20H12.965L13.3245 17.3212C13.8348 17.1879 14.3012 16.9985 14.7235 16.753C15.146 16.5073 15.5534 16.1916 15.9458 15.8057L18.4303 16.85L19.415 15.15L17.2458 13.5155C17.3291 13.2565 17.3858 13.0026 17.4158 12.7537C17.4459 12.5051 17.461 12.2538 17.461 12C17.461 11.7397 17.4459 11.4884 17.4158 11.2463C17.3858 11.0039 17.3291 10.7564 17.2458 10.5038L19.434 8.85L18.4495 7.15L15.936 8.2095C15.6014 7.85183 15.2004 7.53583 14.7333 7.2615C14.2659 6.98717 13.7932 6.79292 13.315 6.67875L12.9995 4H11.015L10.684 6.66925C10.1738 6.78975 9.70277 6.97433 9.27077 7.223C8.8386 7.47183 8.42635 7.79233 8.03402 8.1845L5.54952 7.15L4.56502 8.85L6.72452 10.4595C6.64118 10.6968 6.58285 10.9437 6.54952 11.2C6.51618 11.4563 6.49952 11.7262 6.49952 12.0095C6.49952 12.2698 6.51618 12.525 6.54952 12.775C6.58285 13.025 6.63802 13.2718 6.71502 13.5155L4.56502 15.15L5.54952 16.85L8.02452 15.8C8.40402 16.1897 8.80977 16.5089 9.24177 16.7578C9.67393 17.0064 10.1515 17.1974 10.6745 17.3307L10.9995 20ZM12.011 15C12.843 15 13.551 14.708 14.135 14.124C14.719 13.54 15.011 12.832 15.011 12C15.011 11.168 14.719 10.46 14.135 9.876C13.551 9.292 12.843 9 12.011 9C11.1687 9 10.4581 9.292 9.87927 9.876C9.30043 10.46 9.01102 11.168 9.01102 12C9.01102 12.832 9.30043 13.54 9.87927 14.124C10.4581 14.708 11.1687 15 12.011 15Z"
                                        fill="#B3B3B3"
                                    />
                                </g>
                            </svg>
                            <span>관리처 관리</span>
                        </router-link>
                    </li>
                    <!--테스트 버튼-->
                    <!-- <li>
                        <button @click="testAlarmSend" style="color: #f00; background: gold; padding: 20px">테스트</button>
                    </li> -->
                </ul>
            </nav>
            <a href="javascript:;" class="logout" @click="logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_533_3565" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_533_3565)">
                        <path
                            d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H12.0095V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H12.0095V20.5H5.30775ZM16.2308 16.2692L15.1923 15.1845L17.627 12.75H9.09625V11.25H17.627L15.1923 8.8155L16.2308 7.73075L20.5 12L16.2308 16.2692Z"
                            fill="white"
                        />
                    </g>
                </svg>
                <span>로그아웃</span>
            </a>
        </div>

        <section class="content">
            <router-view :receivedMessage="receivedMessage" :connectMessage="connectMessage" :channel="channel"></router-view>
        </section>

        <!-- 모바일 네비게이션 (로그인화면에선 안보이게) -->
        <FooterMobNavi v-if="$route.path !== '/login'" class="footerNavi" />
    </div>
</template>

<script>
import { supabase } from '@/API/supabase';
import FooterMobNavi from '@/components/layout/footerMobNavi.vue';
import VueCookies from 'vue-cookies';
import S_favicon_default from '@/assets/favicon/S_favicon_default.ico';
import S_favicon_active from '@/assets/favicon/S_favicon_active.ico';
import S_favicon_error from '@/assets/favicon/S_favicon_error.ico';
import R_favicon_default from '@/assets/favicon/R_favicon_default.ico';
import R_favicon_active from '@/assets/favicon/R_favicon_active.ico';
import R_favicon_error from '@/assets/favicon/R_favicon_error.ico';

export default {
    name: 'DefaultLayout',
    inject: ['audioFiles'], // main.js에서 주입된 audioFiles
    data() {
        return {
            isEditableAccount: this.$store.state.user.data.is_editable_account == '1' ? true : false,
            alarmMenuName: '비상벨 알람 현황',
            defaultImg: require('@/assets/img/user.png'),
            isMiniSidebar: false,
            menuVisible: false,
            menuOpen: false,
            user_id: '',
            comp_id: '',
            auth: '',
            display_name: '',
            thumb: '',
            thumbnailUrl: '',
            selectedUserId: '',
            showLogoutMenu: false,
            //실시간 변수
            channel: null,
            receivedMessage: null,
            connectMessage: null,
            originalTitle: '', // 원래 타이틀 저장
            originalFavicon: null,
            domainType: '',
            alarmList: [],
            isTabActive: true,
            currentAudio: null, // 현재 재생 중인 오디오 객체를 저장
            totalBellList: [],

            soundMap: {}, // 소리번호 => Audio 객체 매핑
        };
    },
    components: {
        FooterMobNavi,
    },
    computed: {
        menuVisibles() {
            return this.menuOpen;
        },
        iconClass() {
            // 사이드바 토글 아이콘
            return this.isMiniSidebar ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left';
        },
        userRole() {
            if (this.auth === '0') {
                return '통합관리자';
            } else if (this.auth === '1') {
                return '관리자';
            } else {
                return '일반사용자';
            }
        },
    },
    watch: {
        menuVisibles(newVal) {
            if (newVal) {
                // 메뉴가 열리면 body에 overflow: hidden; 추가
                document.body.style.overflow = 'hidden';
            } else {
                // 메뉴가 닫히면 body의 overflow를 기본으로 되돌림
                document.body.style.overflow = '';
            }
        },
    },
    created() {
        window.addEventListener('resize', this.resize);
        this.resize();
    },
    async mounted() {
        if (this.isEditableAccount) {
            this.alarmMenuName = await this.getMenuName();
        }

        if (window.location.hostname.includes('ringosos')) {
            this.originalFavicon = R_favicon_default;
            this.originalTitle = '링고벨 통합 관리 프로그램';
            this.domainType = 'ringobell';

            document.title = this.originalTitle;
            this.changeFavicon(this.originalFavicon);
        } else {
            this.originalFavicon = S_favicon_default;
            this.originalTitle = '씨스콜 - 음성통화비상벨 통합관리 프로그램';
            this.domainType = 'syscall';

            document.title = this.originalTitle;
            this.changeFavicon(this.originalFavicon);
        }

        var user = this.$store.state.user;
        if (user.data) {
            var userInfo = user.data;
            this.user_id = userInfo.user_id;

            // 관리자계정으로 사용자계정 접근 시
            if (this.$route.query.user_id) {
                this.selectedUserId = this.$route.query.user_id;
                await this.getUserInfo();

                if (this.thumb != null && this.thumb != '' && this.thumb != 'null') {
                    this.downloadThumbnail(this.selectedUserId);
                } else {
                    this.thumbnailUrl = this.defaultImg;
                }
            } else {
                this.comp_id = userInfo.comp_id;
                this.auth = userInfo.auth;
                this.display_name = userInfo.display_name;
                this.thumb = userInfo.thumb;

                if (this.thumb != null && this.thumb != '' && this.thumb != 'null') {
                    this.downloadThumbnail(this.user_id);
                } else {
                    this.thumbnailUrl = this.defaultImg;
                }
            }

            await this.getMapData(); // Device 정보 가져오기
            // this.initSounds(); // 컴포넌트 마운트 시 오디오 미리 초기화
            //Realtime 관련
            this.subscribeChannel(); // Realtime 채널 구독
        }

        this.emitter.on('updateProfile', this.updateProfile);

        // 브라우저 창이 활설화/비활성화될 때 감지 이벤트
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.isTabActive = false;
                this.changeTitleAndFaviconOnBlur();
            } else {
                this.isTabActive = true;
                this.resetTitleAndFaviconOnFocus();
            }
        });

        // 오디오 파일 프리로딩 (라우팅 지연 문제 해결)
        Object.values(this.audioFiles).forEach((src) => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'audio';
            link.href = src;
            document.head.appendChild(link);
        });
    },
    beforeUnmount() {
        this.emitter.off('updateProfile', this.updateProfile);
        //Realtime 관련
        if (this.channel) {
            // console.log('채널 구독 해제');
            this.channel.unsubscribe(); // 채널 구독 해제
        }

        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    },
    watch: {
        alarmList: {
            handler() {
                if (!this.isTabActive) {
                    this.changeTitleAndFaviconOnBlur();
                }
            },
            deep: true,
        },
    },
    methods: {
        // Realtime 채널 구독
        async subscribeChannel() {
            if (this.channel && this.channel.isSubscribed) {
                return;
            }
            this.channel = supabase.channel('nttworks'); // 채널 초기화
            // 채널 구독
            const { error } = await this.channel.subscribe();
            if (error) {
                console.error('Error subscribing to channel:', error);
                return;
            }

            // 모든 메시지 수신
            this.channel.on('broadcast', { event: 'nttworks' }, (payload) => {
                const dataType = payload.DataType;

                // 해당 계정에 등록된 Device가 없으면 알람발생 X
                const mydevice = this.totalBellList.find((item) => item.device_id === payload.PhoneNum);
                if (!mydevice) return;
                // console.log('=====받은 메세지====', `\n`, payload, `\n[`, new Date().toLocaleString() + ` ]`);
                this.$seq_console.log(`[${payload.PhoneNum}] payload`, payload);

                //############# 통신장애 조건에서 DeviceTimeOver2 제외됨. 다른 로그 확인용 #############
                // if(payload.DataType !== 'DeviceTimeOver2') {
                //     console.log('=====받은 메세지====', `\n`, payload, `\n[`, new Date().toLocaleString() + ` ]`);
                // }

                this.receivedMessage = payload; //Props 전달

                switch (dataType) {
                    case 'E':
                        //-------- 비상 알람 발생 시 ---------//
                        if (!this.isTabActive) {
                            this.alarmList = [...this.alarmList, payload];
                        }

                        if (payload.Data != 'E/GN5/1010') {
                            // this.playSound();
                            this.playSoundById();
                            this.$seq_console.error(`[${payload.PhoneNum}]비상알람 발생`, payload);
                        }
                        break;
                    case 'H':
                        //-------- 상태 알람 발생 시 ---------//
                        if (!this.isTabActive) {
                            var isError = this.checkAlarmStatus(payload);
                            if (isError) {
                                this.alarmList = [...this.alarmList, payload];
                            }
                        }
                        break;
                    case 'Connect':
                        //-------- 연결 감지 시 ---------//
                        // this.getList();
                        this.connectMessage = payload;
                        // console.log('=====받은 메세지====', `\n`, payload, `\n[`, new Date().toLocaleString() + ` ]`);
                        if (payload.Data == '0') {
                            this.alarmList = [...this.alarmList, payload];
                            this.$seq_console.warn(`[${payload.PhoneNum}] 상태알람 - 통신장애(연결 끊김)`, payload);
                        }
                        break;
                    default:
                        break;
                }
            });
        },

        // 알람 상태 체크 (*'H'로 들어오는 데이터들 중 이상데이터를 감지하기 위함)
        checkAlarmStatus(payload) {
            var isError = false;
            var rsrp = payload.Data.split('/')[1];
            var battery = payload.Data.split('/')[3];

            // 정상범위 이외의 RSRP일 경우
            if (rsrp > -110) {
                isError = false;
            } else if (rsrp >= -114 && rsrp <= -110) {
                isError = true;
                this.$seq_console.warn(`[${payload.PhoneNum}] 상태알람 - 감도주의`, payload);
            } else {
                isError = true;
                this.$seq_console.warn(`[${payload.PhoneNum}] 상태알람 - 통신장애(RSRP -114 미만)`, payload);
            }

            //'보조전원'일 경우
            if (battery == '02' || battery == '2') {
                isError = true;
                this.$seq_console.warn(`[${payload.PhoneNum}] 상태알람 - 보조전원`, payload);
            }
            return isError;
        },

        async playSoundById() {
            const melody = VueCookies.get('nttworks_melody');
            const soundKey = `Melody${melody}`; // 'Melody2'
            const sound = VueCookies.get('nttworks_sound');

            if (!melody || sound !== 'on') {
                //await this.$alert(`melody: ${melody}, sound: ${sound}`, '알림');
                return;
            }

            // const audio = this.soundMap[soundKey];
            const audioSrc = this.audioFiles[soundKey]; // audioFiles에서 URL 가져오기

            // 현재 재생 중인 오디오가 있다면 중지
            if (this.currentAudio) {
                this.currentAudio.pause();
                this.currentAudio.currentTime = 0;
            }

            if (audioSrc) {
                // 새로운 오디오 생성 및 재생
                this.currentAudio = new Audio(audioSrc);
                this.currentAudio.play().catch((err) => {
                    console.error(err);
                });
            } else {
                console.warn('해당 ID의 소리가 없습니다:', melody, 'audio: ', audio);
                // await this.$alert(`해당 ID의 소리가 없습니다: ${melody}, audio: ${sound}`, '알림');
            }
        },

        // 지도 데이터 가져오기
        async getMapData() {
            try {
                const { data, error } = await supabase.rpc('get_latest_device_alarm_info', {
                    pm_user_id: this.selectedUserId ? this.selectedUserId : this.user_id,
                });

                this.totalBellList = data;
            } catch (error) {
                console.error('오류 발생:', error.message);
            }
        },

        // 사용자 정보 가져오기
        async getUserInfo() {
            try {
                const { data, error } = await supabase
                    .from('UserInfo')
                    .select(
                        `
                            Display, thumb, auth, melody, sound, rows_per_page,
                            comp_info: Company!left(comp_id, comp_name)
                        `,
                    )
                    .eq('user_id', this.selectedUserId)
                    .maybeSingle();

                if (data) {
                    this.comp_id = data.comp_info.comp_id;
                    this.display_name = data.Display;
                    this.thumb = data.thumb;
                    this.auth = data.auth;

                    this.$store.commit('resetSound', data);
                    this.$store.commit('resetPage', data);
                } else {
                    console.error(error.message);
                }
            } catch (err) {
                console.error('Error loading data:', err.message);
            }
        },

        // 썸네일 다운로드
        async downloadThumbnail(user_id) {
            const { data, error } = await supabase.storage.from('thumbnail').download(`images/${user_id}`);

            if (error) {
                console.error(error);
                return;
            } else {
                const blobUrl = URL.createObjectURL(data);
                this.thumbnailUrl = blobUrl; // <img> 태그에 적용
            }
        },

        // 프로필 업데이트
        updateProfile(data) {
            this.thumb = data.thumb;
            if (this.thumb != null && this.thumb != '') {
                if (this.selectedUserId) {
                    this.downloadThumbnail(this.selectedUserId);
                } else {
                    this.downloadThumbnail(this.user_id);
                }
            } else {
                this.thumbnailUrl = '';
            }
        },

        toggleSidebar() {
            this.isMiniSidebar = !this.isMiniSidebar;
        },

        // 화면이 리사이즈 될 때마다 isMiniSidebar를 true로 변경
        resize() {
            if (window.innerWidth < 1024) {
                this.isMiniSidebar = true;
            } else {
                this.isMiniSidebar = false;
            }
        },

        // 모바일 토글메뉴
        toggleMenu() {
            this.menuVisible = !this.menuVisible;
            this.menuOpen = !this.menuOpen;
        },

        // 모바일 메뉴에서 메뉴 클릭 시 메뉴 닫기
        closeMenu() {
            this.menuVisible = false;
            this.menuOpen = false;
        },

        // 로그아웃
        async logout() {
            var result = await this.$confirm('로그아웃 하시겠습니까?');
            if (result) {
                var params = {
                    user_id: this.user_id,
                };

                this.$store
                    .dispatch('UserAccountStore/logout', params)
                    .then((res) => {
                        // console.log(res);
                        if (res.success) {
                            this.$store.commit('logoutUser');

                            // 앱쪽으로 URL 전달
                            if (window.jsBridge && typeof window.jsBridge.postMessage === 'function') {
                                window.jsBridge.postMessage('logout');
                            }

                            this.$router.push('/login');
                        }
                        return res;
                    })
                    .catch(({ message }) => alert(message));
            }
        },

        toggleLogoutMenu() {
            this.showLogoutMenu = !this.showLogoutMenu;
        },

        // 브라우저 창이 비활성화될 때 타이틀과 파비콘 변경
        changeTitleAndFaviconOnBlur() {
            if (this.alarmList.length > 0) {
                var finalAlarmType = '';
                for (var i = 0; i < this.alarmList.length; i++) {
                    if (this.alarmList[i].DataType == 'E') {
                        finalAlarmType = 'E';
                        break;
                    } else if (this.alarmList[i].DataType == 'H') {
                        if (finalAlarmType != 'E') {
                            finalAlarmType = 'H';
                        }
                    } else if (this.alarmList[i].DataType == 'DeviceTimeOver2') {
                        finalAlarmType = 'DeviceTimeOver2';
                    } else if (this.alarmList[i].DataType == 'Connect' && this.alarmList[i].Data == '0') {
                        finalAlarmType = 'Connect0';
                    }
                }

                var webTitle = '';
                if (this.domainType == 'syscall') {
                    if (finalAlarmType == 'E') {
                        webTitle = `(${this.alarmList.length}) 씨스콜 - 알람발생!`;
                        this.changeFavicon(S_favicon_active);
                    } else if (finalAlarmType == 'H' || finalAlarmType == 'DeviceTimeOver2' || finalAlarmType == 'Connect0') {
                        webTitle = `(${this.alarmList.length}) 씨스콜 - 상태알람발생!`;
                        this.changeFavicon(S_favicon_error);
                    }
                } else {
                    if (finalAlarmType == 'E') {
                        webTitle = `(${this.alarmList.length}) 링고벨 비상 알람 발생!`;
                        this.changeFavicon(R_favicon_active);
                    } else if (finalAlarmType == 'H' || finalAlarmType == 'DeviceTimeOver2' || finalAlarmType == 'Connect0') {
                        webTitle = `(${this.alarmList.length}) 링고벨 상태 알람 발생!`;
                        this.changeFavicon(R_favicon_error);
                    }
                }
                document.title = webTitle;
            }
        },

        // 브라우저 창이 활성화될 때 타이틀과 파비콘 변경
        resetTitleAndFaviconOnFocus() {
            document.title = this.originalTitle;
            this.changeFavicon(this.originalFavicon); // 원래 파비콘으로 복원
            this.alarmList = [];
        },

        // 파비콘 변경
        changeFavicon(iconUrl) {
            // 기존 favicon 요소 찾기
            let link = document.querySelector("link[rel='icon']");

            if (link) {
                // 기존 favicon을 삭제 후 다시 추가 (캐싱 문제 방지)
                document.head.removeChild(link);
            } else {
                // 새 favicon 요소 생성
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }

            // 새로운 favicon 적용
            link.href = iconUrl + '?v=' + new Date().getTime(); // 캐싱 방지 위해 타임스탬프 추가
            document.head.appendChild(link);
        },

        async getMenuName() {
            try {
                const { data, error } = await supabase.from('EditableUI').select('menu_name').single();
                if (error) {
                    throw new Error(error);
                }

                if (data) {
                    return data.menu_name;
                }
            } catch (error) {
                console.error(error);
                this.$alert('데이터를 불러오는 중 에러가 발생했습니다.', '알림');
            }
        },
    },
};
</script>
